import { TypeAsserter } from '@attain-apps/type-guards'

import * as core from '../../core'

import type { Organization } from './organizations'
import type { Record } from './record'

export type Cluster = core.common.Identified<Cluster.Id> &
  core.common.Named &
  core.common.Described.Optionally &
  core.common.Coded & {
    assignedSpaceIds: Record.Id[]
    organization: Organization.Lookup
    comment?: string
  }
export namespace Cluster {
  export type Id = core.dms.data.Record.Id
  export namespace Id {
    export const isId = core.dms.data.Record.Id.isId
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export type RecordAssignment = Pick<
    Record,
    | 'id'
    | 'name'
    | 'code'
    | 'ancestors'
    | 'entityId'
    | 'roomTypeId'
    | 'occupierId'
  >

  export type Update = Partial<
    Pick<Cluster, 'name' | 'description' | 'comment'>
  >
  export type Input = Pick<Cluster, 'name' | 'description'> & {
    organizationId: Organization.Id
  }

  export interface Filter {
    /**
     * Ids of Clusters user want to retrieve
     */
    ids?: readonly Id[]
    /** Ids of Clusters that user has access */
    accessibleClusterIds?: readonly Id[]
  }
}
